import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2"

import Row from "../../../../common/components/Row"
import PaperIcon from "../PaperIcon"
import { getIconForPerkCategory } from "./PerksEditor"

export default function PerksColumns({ perks }) {
  const sortedPerks = perks.slice()
  sortedPerks.sort(({ category: category1 }, { category: category2 }) =>
    category1 > category2 ? 1 : category1 < category2 ? -1 : 0
  )
  return (
    <Grid container rowSpacing={2}>
      {sortedPerks.length === 0 ? (
        <Grid xs={12}>
          <Typography variant="body1" color="text.secondary2">
            No perks selected.
          </Typography>
        </Grid>
      ) : (
        sortedPerks.map((perk, index) => (
          <Grid key={perk.id} xs={12} md={6}>
            <PerkRow perk={perk} />
          </Grid>
        ))
      )}
    </Grid>
  )
}

function PerkRow({ perk }) {
  const Icon = getIconForPerkCategory(perk.category)
  return (
    <Row
      sx={{
        alignItems: "center",
        gap: 1,
      }}
    >
      <PaperIcon>
        <Icon />
      </PaperIcon>
      <Typography variant="body1" color="text.secondary">
        {perk.title}
      </Typography>
    </Row>
  )
}
